import { Box } from '@mui/material'

function App() {
  return (
    <Box>
      Hello! I'm Matt.
    </Box>
  )
}

export default App